import AR from "@/locales/ar/ar";
import EVENTS_AR from "@/locales/ar/events-ar";
import RESOURCES_AR from "@/locales/ar/resources-ar";
import ROLES_AR from "@/locales/ar/roles-ar";
import STATUSES_AR from "@/locales/ar/statuses-ar";
import DE from "@/locales/de/de";
import EVENTS_DE from "@/locales/de/events-de";
import RESOURCES_DE from "@/locales/de/resources-de";
import ROLES_DE from "@/locales/de/roles-de";
import STATUSES_DE from "@/locales/de/statuses-de";
import EN from "@/locales/en/en";
import EVENTS_EN from "@/locales/en/events-en";
import RESOURCES_EN from "@/locales/en/resources-en";
import ROLES_EN from "@/locales/en/roles-en";
import STATUSES_EN from "@/locales/en/statuses-en";
import ES from "@/locales/es/es";
import EVENTS_ES from "@/locales/es/events-es";
import RESOURCES_ES from "@/locales/es/resources-es";
import ROLES_ES from "@/locales/es/roles-es";
import STATUSES_ES from "@/locales/es/statuses-es";
import EVENTS_FR from "@/locales/fr/events-fr";
import FR from "@/locales/fr/fr";
import RESOURCES_FR from "@/locales/fr/resources-fr";
import ROLES_FR from "@/locales/fr/roles-fr";
import STATUSES_FR from "@/locales/fr/statuses-fr";
import EVENTS_IT from "@/locales/it/events-it";
import IT from "@/locales/it/it";
import RESOURCES_IT from "@/locales/it/resources-it";
import ROLES_IT from "@/locales/it/roles-it";
import STATUSES_IT from "@/locales/it/statuses-it";
import EVENTS_PT from "@/locales/pt/events-pt";
import PT from "@/locales/pt/pt";
import RESOURCES_PT from "@/locales/pt/resources-pt";
import ROLES_PT from "@/locales/pt/roles-pt";
import STATUSES_PT from "@/locales/pt/statuses-pt";

const TRANSLATIONS = {
  ar: {
    events: EVENTS_AR,
    resources: RESOURCES_AR,
    roles: ROLES_AR,
    statues: STATUSES_AR,
    translation: AR,
  },
  de: {
    events: EVENTS_DE,
    resources: RESOURCES_DE,
    roles: ROLES_DE,
    statues: STATUSES_DE,
    translation: DE,
  },
  en: {
    events: EVENTS_EN,
    resources: RESOURCES_EN,
    roles: ROLES_EN,
    statues: STATUSES_EN,
    translation: EN,
  },
  es: {
    events: EVENTS_ES,
    resources: RESOURCES_ES,
    roles: ROLES_ES,
    statues: STATUSES_ES,
    translation: ES,
  },
  fr: {
    events: EVENTS_FR,
    resources: RESOURCES_FR,
    roles: ROLES_FR,
    statues: STATUSES_FR,
    translation: FR,
  },
  it: {
    events: EVENTS_IT,
    resources: RESOURCES_IT,
    roles: ROLES_IT,
    statues: STATUSES_IT,
    translation: IT,
  },
  pt: {
    events: EVENTS_PT,
    resources: RESOURCES_PT,
    roles: ROLES_PT,
    statues: STATUSES_PT,
    translation: PT,
  },
};

export default TRANSLATIONS;
